import VS from 'constants/ValidationShema';
import Tr from "translations/Translations";
import AnnualReportNoticeSource from "./AnnualReportNoticeSource";

const purchaser = VS.object({
    dataLoaded: VS.requiredBoolean(),
    purchaserName: VS.any().when(["complete", "dataLoaded"], {
        is: (complete, dataLoaded) => complete && !dataLoaded,
        then: VS.stringMax(300),
        otherwise: VS.stringMaxNoRq(300)
    }),
    purchaserPartName: VS.stringMaxNoRq(300),
    purchaserIdentifier: VS.any().when(["complete", "dataLoaded"], {
        is: (complete, dataLoaded) => complete && !dataLoaded,
        then: VS.stringMax(100),
        otherwise: VS.stringMaxNoRq(100)
    }),
    purchaserType: VS.any().when(["complete", "dataLoaded"], {
        is: (complete, dataLoaded) => complete && !dataLoaded,
        then: VS.string().nullable(),
        otherwise: VS.stringNoRq().nullable()
    }),
    purchaserOtherType: VS.any().when(["complete", "dataLoaded", "purchaserType"], {
        is: (complete, dataLoaded, purchaserType) => complete && !dataLoaded && purchaserType === "1.5",
        then: VS.stringMax(200),
        otherwise: VS.stringMaxNoRq(200)
    }),
    purchaserActivityType: VS.any(),
    purchaserStreet: VS.any().when(["complete", "dataLoaded"], {
        is: (complete, dataLoaded) => complete && !dataLoaded,
        then: VS.stringMax(100),
        otherwise: VS.stringMaxNoRq(100)
    }),
    purchaserCity: VS.any().when(["complete", "dataLoaded"], {
        is: (complete, dataLoaded) => complete && !dataLoaded,
        then: VS.stringMax(200),
        otherwise: VS.stringMaxNoRq(200)
    }),
    purchaserCode: VS.any().when(["complete", "dataLoaded"], {
        is: (complete, dataLoaded) => complete && !dataLoaded,
        then: VS.stringMax(100),
        otherwise: VS.stringMaxNoRq(100)
    }),
    purchaserProvince: VS.any(),
    purchaserCountry: VS.any().when(["complete", "dataLoaded"], {
        is: (complete, dataLoaded) => complete && !dataLoaded,
        then: VS.string().nullable(),
        otherwise: VS.stringNoRq().nullable()
    }),
    purchaserUrl: VS.any().when(["complete", "dataLoaded"], {
        is: (complete, dataLoaded) => complete && !dataLoaded,
        then: VS.urlMax(250).nullable(),
        otherwise: VS.string(250).nullable()
    }),
    purchaserEmail: VS.any().when(["complete", "dataLoaded"], {
        is: (complete, dataLoaded) => complete && !dataLoaded,
        then: VS.emailMax(250).nullable(),
        otherwise: VS.emailMaxNoRq(250).nullable()
    }),
    purchaserPhone: VS.any().when(["complete", "dataLoaded"], {
        is: (complete, dataLoaded) => complete && !dataLoaded,
        then: VS.stringMax(100),
        otherwise: VS.stringMaxNoRq(100)
    }),
    issueNumber: VS.any().when("complete", {is: true, then: VS.stringMax(100), otherwise: VS.stringMaxNoRq(100)}),
    complete: VS.requiredBoolean()
})
const belowEu = VS.object({
    type: VS.string(),
    number: VS.stringMax(50),
    orderType: VS.string(),
    amount: VS.any().when("complete", {is: true, then: VS.amount(0, false), otherwise: VS.any()}),
    complete: VS.requiredBoolean()
})

const aboveEu = VS.object({
    type: VS.string(),
    number: VS.stringMax(50),
    noticeNumber: VS.any().when("complete", {is: true, then: VS.stringMax(50), otherwise: VS.stringMaxNoRq(50)}),
    orderType: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    codeCPV: VS.any().when("complete", {is: true, then: VS.requiredObject(), otherwise: VS.any()}),
    tenderMode: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    contractorCountryList: VS.any().when("complete", {is: true, then: VS.arrayRequired(), otherwise: VS.any()}),
    contractValue: VS.any().when("complete", {is: true, then: VS.amount(0, true), otherwise: VS.any()}),
    numberOfAwardedLots: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    numberOfOffers: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    numberOfRejectedOffers: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    numberOfOffersSubmittedByMMSP: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    contractAwardedToMMSP: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    complete: VS.requiredBoolean()
})

const conflict = VS.object({
    type: VS.string(),
    source: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    number: VS.stringMax(50),
    noticeNumber: VS.any().when("complete", {is: true, then: VS.stringMax(50), otherwise: VS.stringMaxNoRq(50)}),
    orderType: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    codeCpv: VS.any().when("complete", {is: true, then: VS.requiredObject(), otherwise: VS.any()}),
    tenderModeBzp: VS.any().when(["complete", "source"], {is: (complete, source) => complete && source === AnnualReportNoticeSource.BZP, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    tenderModeTed: VS.any().when(["complete", "source"], {is: (complete, source) => complete && source === AnnualReportNoticeSource.TED, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    numberOfCasesOfConflictOfInterest: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    numberOfDetectedAgreements: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    numberOfContractorsWithRejectedOffer: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    complete: VS.requiredBoolean()
})

const community = VS.object({
    type: VS.string(),
    source: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    number: VS.stringMax(50),
    noticeNumber: VS.any().when("complete", {is: true, then: VS.stringMax(50), otherwise: VS.stringMaxNoRq(50)}),
    serviceDescription: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    codeCpv: VS.any().when("complete", {is: true, then: VS.requiredObject(), otherwise: VS.any()}),
    tenderModeBzp: VS.any().when(["complete", "source"], {is: (complete, source) => complete && source === AnnualReportNoticeSource.BZP, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    tenderModeTed: VS.any().when(["complete", "source"], {is: (complete, source) => complete && source === AnnualReportNoticeSource.TED, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    reservedTender: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    amount: VS.any().when("complete", {is: true, then: VS.amount(0, true), otherwise: VS.any()}),
    numberOfAwardedLots: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    numberOfOffers: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    numberOfOffersMMSP: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    complete: VS.requiredBoolean()
})

const social = VS.object({
    type: VS.string(),
    source: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    number: VS.stringMax(50),
    noticeNumber: VS.any().when("complete", {is: true, then: VS.stringMax(50), otherwise: VS.stringMaxNoRq(50)}),
    orderType: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    codeCpv: VS.any().when("complete", {is: true, then: VS.requiredObject(), otherwise: VS.any()}),
    tenderModeBzp: VS.any().when(["complete", "source"], {is: (complete, source) => complete && source === AnnualReportNoticeSource.BZP, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    tenderModeTed: VS.any().when(["complete", "source"], {is: (complete, source) => complete && source === AnnualReportNoticeSource.TED, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    contractValue: VS.any().when("complete", {is: true, then: VS.amount(0, true), otherwise: VS.any()}),
    numberOfAwardedLots: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    numberOfOffers: VS.any().when("complete", {is: true, then: VS.integerMin(), otherwise: VS.any()}),
    reservedTender: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    inDescriptionRequirementsForAccessibility: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    definedSocialAspectsInOfferEvaluationCriteria: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    definedRequirementsBasedOnEmploymentRelationship: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    definedSocialAspectsRequirements: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    definedLabelRelatedToSocialAspects: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    contractorType: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    complete: VS.requiredBoolean()
})

const innovative = VS.object({
    type: VS.string(),
    source: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    number: VS.stringMax(50),
    noticeNumber: VS.any().when("complete", {is: true, then: VS.stringMax(50), otherwise: VS.stringMaxNoRq(50)}),
    orderType: VS.any().when("complete", {is: true, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    codeCpv: VS.any().when("complete", {is: true, then: VS.requiredObject(), otherwise: VS.any()}),
    tenderModeBzp: VS.any().when(["complete", "source"], {is: (complete, source) => complete && source === AnnualReportNoticeSource.BZP, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    tenderModeTed: VS.any().when(["complete", "source"], {is: (complete, source) => complete && source === AnnualReportNoticeSource.TED, then: VS.string().nullable(), otherwise: VS.stringNoRq().nullable()}),
    contractValue: VS.any().when("complete", {is: true, then: VS.amount(0, true), otherwise: VS.any()}),
    environmentalRequirements: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    environmentalManagementSystemAndStandards: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    environmentalAspectsInEvaluationCriteria: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    costCriterionUsingLifeCycleCostingApplied: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    environmentalAspectsRequirements: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    labelRelatedToEnvAspectsOrMeasureOfEvidence: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    innovativeAspectsInEvaluationCriteria: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    innovativeAspectsRequirements: VS.any().when("complete", {is: true, then: VS.requiredBoolean(), otherwise: VS.any()}),
    complete: VS.requiredBoolean()
})

const exception = VS.object({
    type: VS.any().when("complete", {is: true, then: VS.stringNotOneOf(["0"], Tr('required_field')), otherwise: VS.string()}),
    number: VS.stringMax(50),
    name: VS.stringMaxNoRq(400),
    contractValue: VS.any().when("complete", {is: true, then: VS.amount(0, false), otherwise: VS.any()}),
    complete: VS.requiredBoolean()
})

const notIncluded = VS.object({
    type: VS.string(),
    number: VS.stringMax(50),
    name: VS.stringMaxNoRq(400),
    contractValue: VS.any().when("complete", {is: true, then: VS.amount(0, true), otherwise: VS.any()}),
    complete: VS.requiredBoolean()
})

export default {
    purchaser,
    belowEu,
    aboveEu,
    conflict,
    community,
    social,
    innovative,
    exception,
    notIncluded
}